import React from 'react';
import { graphql } from 'react-apollo';
import { GET } from "../../../queries/network";
import MenuItem from '@material-ui/core/MenuItem';
import { InputLabel, Select, Input } from '@material-ui/core';

const networksFunc = ({ form: { form }, networksData:{ networksData }, onChange: networksChange, data: { networks, loading, error }}) => {
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  const handleChange = (e) => {
    if(networksChange){
    networksChange(e.target.value);
    }
  }
  return (
    <>
    {
    form.getFieldDecorator('networks',
           {
            initialValue: (networksData || '')
          })(<>
            <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Networks</InputLabel>
            <Select
            labelId="mutiple-name-label"
            id="networks-lookup-id"
            multiple
            value={networksData}
            onChange={handleChange}
            input={<Input />}
            style={{ width : '100%' }}
            >
            {networks.map(item => (
                <MenuItem key={item.id} value={item.id}>
                {item.name}
                </MenuItem>
            ))}
            </Select>
            </>
          )}
    </>
        
  );
}
export const NetworksLookup = graphql(GET)((networksFunc));